<template>
  <transition name="panel-slide">
    <div
      v-if="ctrlDisplayPanelGet"
      v-click-outside="clickedOutsidePanel"
      class="right-panel">
      <PanelDetails
        v-if="userDetailsSectionShown"
        class="content"/>
      <PanelMenu
        :menu-acts-as-toggle="menuActsAsToggle"
        class="menu"
        @hide="closePanel" />
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import ClickOutside from 'v-click-outside';
import PanelDetails from './partials/PanelDetails';
import PanelMenu from './partials/PanelMenu';

export default {
  name: 'RightPanel',
  directives: {
    ClickOutside: ClickOutside.directive,
  },
  components: { PanelMenu, PanelDetails },
  props: {
    initialSection: {
      type: String,
      required: false,
      default: '',
    },
    initiallyDisplayed: {
      type: Boolean,
      required: false,
      default: false,
    },
    menuActsAsToggle: {
      type: Boolean,
      required: false,
      default: true,
    },
    ignoreDropdownClose: {
      type: Boolean,
      required: false,
      default: true,
      description: 'if true, panel will not close when clickOutside was triggered while a dropdown was open',
    },
  },
  data() {
    return {
      userDetailsSectionShown: 'info',
      panelDisplayed: true,
      shownDropdowns: 0,
    };
  },
  computed: {
    ...mapGetters({
      ctrlDisplayPanelGet: 'contactDetails/ctrlPanelDisplayedGet',
    }),
  },
  mounted() {
    // set initial display state
    this.storeActiveSectionSet(this.initialSection);
    this.$root.$on('bv::dropdown::show', this.dropdownShow);
    this.$root.$on('bv::dropdown::hide', this.dropdownHide);
  },
  beforeDestroy() {
    this.$root.$off('bv::dropdown::show', this.dropdownShow);
    this.$root.$off('bv::dropdown::hide', this.dropdownHide);
  },
  methods: {
    ...mapMutations({
      ctrlDisplayPanelSet: 'contactDetails/CTRL_PANEL_DISPLAYED_SET',
      storeActiveSectionSet: 'contactDetails/CTRL_ACTIVE_SECTION_SET',
    }),
    dropdownShow() {
      // console.log('shown');
      this.shownDropdowns += 1;
    },
    dropdownHide() {
      // console.log('hidden');
      this.shownDropdowns -= 1;
    },
    clickedOutsidePanel(event) {
      if (this.ignoreDropdownClose && this.shownDropdowns > 0) {
        return;
      }
      const elements = event.path || (event.composedPath && event.composedPath());
      // eslint-disable-next-line no-unused-expressions
      elements && elements.length > 0 && elements.unshift(event.target);
      // ignore closing the panel if some element has do-not-close-panel attribute
      // also, check if hasAttribute exists, document and window don't have it
      if (!elements.find(e => e.hasAttribute && e.hasAttribute('do-not-close-right-panel'))) {
        this.ctrlDisplayPanelSet(false);
      }
    },
    closePanel() {
      this.ctrlDisplayPanelSet(false);
    },
  },
};
</script>

<style lang="scss" scoped>
.right-panel {
  max-width: 316px;
  display: flex;
  align-items: stretch;
}

.panel-slide-enter-active {
  transition: all .8s;
}
.panel-slide-leave-active {
  transition: all .3s 0ms;
}
.panel-slide-enter, .panel-slide-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
  width: 0;
}

.panel-slide-enter-to, .panel-slide-leave
  /* .slide-fade-leave-active below version 2.1.8 */ {
  width: 100%;
}

</style>
